'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/yearsBefore.js
// module id = 764
// module chunks = 0